<template>
  <div
    class="row gutters-sm d-inline-block"
    :class="`justify-content-${justifyContent}` "
  >
    <div class="col-auto align-self-stretch d-inline-block">
      <slot name="left" />
    </div>
    <div class="col-auto d-inline-block">
      <span
        :id="`popover-${id}`"
        data-toggle="popover"
        data-placement="top"
      >
        <i class="fal fa-info-circle" />
      </span>
      <b-popover
        :target="`popover-${id}`"
        triggers="hover"
        :placement="popoverPlacement"
        :noninteractive="true"
      >
        <slot name="popover-body" />
      </b-popover>
    </div>
    <div
      class="ml-auto"
      v-if="options"
    >
      <slot name="options-body" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'BaseHelpTooltip',
  props: {
    justifyContent: {
      type: String,
      default: 'left',
    },
    popoverPlacement: {
      type: String,
      default: 'top',
    },
    options: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      id: null,
    };
  },
  mounted() {
    // eslint-disable-next-line no-underscore-dangle
    this.id = this._uid;
  },
};
</script>
